import {setProposalList} from "./actions";

export const SET_PROPOSAL_LIST = 'SET_PROPOSAL_LIST'
export const SET_PROPOSAL_LIST_META = 'SET_PROPOSAL_LIST_META'
export const SET_PROPOSAL_LIST_BY_DATE = 'SET_PROPOSAL_LIST_BY_DATE'
export const SET_PROPOSAL_LIST_BY_HOUR = 'SET_PROPOSAL_LIST_BY_HOUR'
export const SET_PROPOSAL_LIST_FILTER_DATA = 'SET_PROPOSAL_LIST_FILTER_DATA'

export const PROPOSAL_INIT_STATE = {
    proposalList: [],
    proposalListMeta: {},
    proposalListByDate: [],
    proposalListByHour: [],
    proposalListFilterData: [],
};
